var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-charts',{ref:"bar",attrs:{"autoresize":"","options":_vm.bar,"theme":"ovilia-green","auto-resize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }